module.exports = "<app-exceptional-coefficients-list></app-exceptional-coefficients-list>"